import { useState, useCallback } from 'react';
import {
  GlobalLEReportsPageResponse,
  GlobalLEReportsPageQueryParams,
  ESnackbarStyle,
} from 'shared/types';
import { openNotification } from 'utils/notification-utils';
import { getGlobalLEReportsPage } from 'services/api/globalLEReportsPageService';
import { useDebounce } from 'shared/hooks';

interface GlobalLEReportsPageDataResult {
  data: GlobalLEReportsPageResponse | null;
  isLoading: boolean;
  filterParams: GlobalLEReportsPageQueryParams;
  setFilterParams: (params: GlobalLEReportsPageQueryParams) => void;
  fetchData: () => Promise<void>;
}

const useGlobalLEReportsPageData = (): GlobalLEReportsPageDataResult => {
  const [data, setData] = useState<GlobalLEReportsPageResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [filterParams, setFilterParams] = useState<GlobalLEReportsPageQueryParams>({
    data_source: 'product_d',
  });

  const debouncedParams = useDebounce(filterParams, 300);

  const fetchData = useCallback(async (): Promise<void> => {
    setIsLoading(true);
    try {
      const response = await getGlobalLEReportsPage(debouncedParams);
      setData(response.data);
    } catch (e: any) {
      openNotification(
        ESnackbarStyle.ERROR,
        e.message || 'Failed to fetch Global LE Reports data'
      );
    } finally {
      setIsLoading(false);
    }
  }, [debouncedParams]);

  return { data, isLoading, filterParams, setFilterParams, fetchData };
};

export default useGlobalLEReportsPageData;
